import fullpage from 'fullpage.js'
import 'fullpage.js/dist/fullpage.min.css'
import Player from '@vimeo/player'

(function ($) {
  let allowScrolling = true
  const homepage = $('.page--home')
  const vimeoPlayers = []

  if (!homepage.length) {
    return
  }

  /**
   *
   */
  addEventListener('resize', (event) => {
    const logo = $('.header__logo--animate')
    logo.closest('.header__logo-wrap').css({
      width: Math.ceil(logo.find('.e')[0].getBoundingClientRect().width + 1)
    })

  })

  // initialize fullpage.js
  const fullPageInstance = new fullpage('#fullpage', {
    scrollingSpeed: 1000,
    dragAndMove: true,
    dragAndMoveKey: 'YkdZV3gyWVhKdmRISnBaMjh1WTI5dEE3X09keFpISmhaMEZ1WkUxdmRtVT0xbmw=',
    css3: true,
    licenseKey: '', // TODO: Get license key
    navigation: false,
    normalScrollElements: '.header__menu, .lightbox__content',
    beforeLeave: function (origin, destination) {
      // to prevent footer from breaking the logic
      vimeoPlayers[origin.index] && vimeoPlayers[origin.index].pause()
      vimeoPlayers[destination.index] && vimeoPlayers[destination.index].play()
    },
  })

  // initially, disable scrolling
  // will be enabled after logo finishes animating
  fullPageInstance.setAllowScrolling(false)

  // Animate Logo promise
  const animateLogo = () => {
    return new Promise(res => {
      const logo = $('.header__logo--animate')
      const header = logo.closest('.header')
      header.addClass('animation--start')

      // resolve promise 1.5s after the start of the animation
      // enable fullpage scrolling
      setTimeout(() => {
        fullPageInstance.setAllowScrolling(true)
        logo.closest('.header__logo-wrap').css({
          width: Math.ceil(logo.find('.e')[0].getBoundingClientRect().width + 1)
        })
        header.addClass('animation--end')
        res(true)
      }, 1500)
    })
  }

  // Disable fullpage scrolling while we're in the header menu
  // and when toggling the lightbox
  $('.header__menu-toggle, [data-lightbox-url], .lightbox__close').on('click', function () {
    allowScrolling = !allowScrolling
    fullPageInstance.setAllowScrolling(allowScrolling)
  })

  // add 'ready' class to eaach project video as it's ready to be played
  homepage.find('.project__video').each(function (index) {
    const target = $(this)
    const player = new Player(target)

    // keep track of page video players
    vimeoPlayers.push(player)

    // when the player is ready to be played
    player.ready().then(() => {
      // if first slide's video is ready, start the logo
      // animation and then resume video to fake the real autoplay
      if (index === 0) {
        animateLogo().then(() => {
          player.play()
        })
      }

      // play and pause the video immediately because
      // the video thumbnail isn't the first frame of the video
      // but is instead a couple of seconds in.
      // this way, the video seamlessly starts playing
      // without any visual "jump" from one frame to another
      player.on('play', () => {
        // pause the video on the very first frame
        player.pause()

        // remove listener as we don't need it anymore
        player.off('play')

        // set the ready class so play button/info becomes visibile
        target.closest('.project').addClass('project--ready')
      })
    })
  })

  $('.back-to-top').on('click', function () {
    if ($(this).closest('.page--home').length) {
      fullPageInstance.moveTo(1)
    }
  })
})(jQuery)
